import { PLAYBACK_RATES } from "../../hooks/useAudios/usePodcastPlayer";

export const SpeedControl = ({ rate, onChange }) => (
  <div className="flex gap-1.5">
    {PLAYBACK_RATES.map((value) => (
      <button
        key={value}
        onClick={() => onChange(value)}
        className="flex-1 h-8 rounded-lg flex items-center justify-center text-xs font-semibold transition-colors"
        style={{
          background: rate === value ? "#e0217a" : "rgba(255,255,255,.07)",
          border: `1px solid ${rate === value ? "#e0217a" : "rgba(255,255,255,.1)"}`,
          color: "#fff",
        }}
      >
        {value}x
      </button>
    ))}
  </div>
);
